import React from 'react';
import PageWrapper from '../../components/page-wrapper/page-wrapper';
import BlogsListPublic from '../../components/blog-display/blogs-list-public';
import HeadingUnderline from '../../components/heading-underline/heading-underline';

const PublicBlogsPage = () => {
  return (
    <PageWrapper>
      <div className="container-fluid section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="display-4 text-red mb-4 text-center">Blog Posts</h1>
              <HeadingUnderline />
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <BlogsListPublic />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default PublicBlogsPage;